// extracted by mini-css-extract-plugin
export var calendar = "calendar-module--calendar--2xeEe";
export var sectionHeading = "calendar-module--sectionHeading--27bKy";